import { Image, List } from "antd-mobile"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import CommonUtil from "../../../utils/CommonUtil"

const InstructionItems = props => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const handleInstructionClick = () => {
        navigate('/instruction_book')
    }

    const handleAccessoryClick = () => {
        navigate('./accessory')
    }
    return <div style={{ background: 'white', borderRadius: 16, marginTop: 15 }}>
        <List mode='card'>
            <List.Item prefix={
                <div style={{ marginRight: -7 }}>
                    <Image
                        src={`${CommonUtil.getSourceDomain()}instruction_icon.png`}
                        fit='cover'
                        width={24}
                        height={24}
                    />
                </div>
            }
                onClick={handleInstructionClick}>
                {t('instruction_book')}
            </List.Item>
            <div className='seperate' />
            <List.Item
                prefix={
                    <div style={{ marginRight: -7 }}>
                        <Image
                            src={`${CommonUtil.getSourceDomain()}accessory_icon.png`}
                            fit='cover'
                            width={24}
                            height={24}
                        />
                    </div>
                } onClick={handleAccessoryClick}>{t('accessory_use')}</List.Item>
        </List>
    </div>
}

export default InstructionItems